import "./footer.component.scss";

const FooterCreatedByComponent = ({ standAlone = false }) => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically

  return (
    <div
      className={standAlone ? "text-center bg-[#2B2D33] text-white px-2 py-12" : ""}
    >
      <small>
        <div>© {currentYear} All Rights Reserved</div>
        <div>Made by Exxeta | Privacy Policy</div>
      </small>
    </div>
  );
};

export default FooterCreatedByComponent;
